module.exports = __webpack_public_path__ + "img/slogan.ce51dbb7.png";